export default class AccountType {
  static SERVICE_PROVIDER = 1;

  static AGENCY = 2;

  static CLIENT = 3;

  static COMPANY = 4;

  static isServiceProvider(status: number): boolean {
    return (status === this.SERVICE_PROVIDER);
  }

  static isAgency(status: number): boolean {
    return (status === this.AGENCY);
  }

  static isClient(status: number): boolean {
    return (status === this.CLIENT);
  }

  static isCompany(status: number): boolean {
    return (status === this.COMPANY);
  }
}
